<template>
  <div class="col-xs-12">
    <div class="row">
      <div class="col-xs-10 col-xs-offset-1 col-sm-12 col-sm-offset-0">
        <div :class="mainHeadClasses">
          <h1 class="gen-config__title gen-config__title--alt-gradimages">
            {{ offerPackage.CatalogPackage.RetailName }}
          </h1>
          <h2 class="gen-config__starting-at-subtitle">
            {{ offerPackage.CostLeadInString }}
            <span class="gen-config__starting-at-subtitle-price">
              {{ offerPackage.EffectiveCostFormatted }}
            </span>
          </h2>
          <div class="catalog__main-head-description catalog__main-head-description--alt-gradimages">
            {{ offerPackage.CatalogPackage.RetailDescription }}
          </div>
        </div>
      </div>
    </div>
    <div :class="primaryUiRowClasses">
      <div class="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-0">
        <div
          v-if="packageImage"
          class="product__main-img-wrapper product__main-img-wrapper--no-img-selection product__main-img-wrapper--border"
        >
          <img
            :src="packageImage"
            class="responsive-img"
          >
        </div>
      </div>
      <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-0">
        <photo-book-selection-group
          :option-product="optionProduct"
          :show-validation="showValidation"
          class="photo-book__selection-group"
          @selected-frames-updated="handleSelectedFramesUpdated"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-8 col-sm-offset-2">
        <div class="photo-book__horizontal-rule" />
      </div>
    </div>
    <div
      v-if="offerPackage.CatalogPackage.MaxQtyAllowed > 1"
      class="row"
    >
      <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3">
        <h4 class="gen-config__component-heading">
          <contentful-text
            :item="contentfulText('quantity-label')"
          />
        </h4>
        <div class="product-selection"><div class="row">
          <div class="col-xs-9">
            <div class="product-selection__quantity-description">
              <contentful-text
                :item="contentfulText('quantity-lede')"
              />
            </div>
          </div>
          <div class="col-xs-3">
            <select
              v-model="selectedQuantity"
              aria-label="Quantity"
              class="config-quantity-dropdown__select js-package-option"
            >
              <option
                v-for="option in quantitySelectOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div
      v-if="isTabletOrHigher"
      class="row row--mb-20"
    >
      <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3">
        <div class="row"><div class="col-xs-4">
          <div class="gen-config__total-label">
            <contentful-text
              :item="contentfulText('price-label')"
            />
          </div>
        </div>
          <div class="col-xs-8">
            <div class="gen-config__actual-total gen-config__actual-total--alt-gradimages text-right">
              {{ packageSubTotalFormatted }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-10 col-xs-offset-1 col-sm-4 col-sm-offset-4">
        <div :class="addToCartWrapperClasses">
          <div class="row">
            <div class="col-xs-4 visible-xs-block">
              <div class="add-to-cart__button-price">
                {{ packageSubTotalFormatted }}
              </div>
            </div>
            <div class="col-xs-8 col-sm-12">
              <button
                type="button"
                class="button button--fw center"
                @click="handleAddToCartButtonClick"
              >
                <contentful-text
                  :item="contentfulText('add-to-cart-label')"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="promoBanner"
      class="row"
    >
      <div class="col-xs-12">
        <promo-banner
          :promo-banner="promoBanner"
          :context="promoBannerInlineContext"
        />
      </div>
    </div>
    <div>
      <input
        :value="customerInfo.CustomerRef"
        type="hidden"
        name="PIN"
      >
      <input
        :value="customerInfo.LastName"
        type="hidden"
        name="LastName"
      >
      <input
        v-if="offerPackage.CatalogPackage.MaxQtyAllowed === 1"
        value="1"
        type="hidden"
      >
      <input
        v-for="(selectedFrame, frameIndex) in selectedFrames"
        :key="frameIndex"
        :value="selectedFrame.frameId"
        :name="`PhotoBook_FrameID_${frameIndex}`"
        type="hidden"
      >
    </div>
  </div>
</template>

<script>
import PhotoBookSelectionGroup from './Group'
import PromoBanner from '@Shared/components/PromoBanner'
import ResponsiveBreakpointMixin from '@Shared/mixins/responsive-breakpoints'
import ToastMixin from '@Shared/mixins/toast'
import currencyFormatter from '@/shared/lib/currency-formatter'
import { range } from 'lodash'

export default {
  name: 'PhotoBook',
  components: {
    PhotoBookSelectionGroup,
    PromoBanner
  },
  mixins: [
    ResponsiveBreakpointMixin,
    ToastMixin
  ],
  data () {
    return {
      selectedFrames: [],
      showValidation: false,
      selectedQuantity: 1
    }
  },
  computed: {
    customerInfo () {
      return this.$store.state.catalogPageCommon.customerInfo
    },
    offerPackage () {
      return this.$store.state.catalogPageCommon.offerPackage
    },
    packageImage () {
      return this.$store.state.packageImage
    },
    mainHeadClasses () {
      return {
        'catalog__main-head': true,
        'catalog__main-head--alt-gradimages': true,
        'catalog__main-head--no-bottom-border': true
      }
    },
    addToCartWrapperClasses () {
      return {
        'add-to-cart__wrapper': true,
        'affix-applied': this.isMobile, // using the legacy classes for fixing the "add to cart" button to the bottom of the screen on mobile
        'affix': this.isMobile // see above comment
      }
    },
    quantitySelectOptions () {
      const numbers = range(1, this.offerPackage.CatalogPackage.MaxQtyAllowed + 1, 1)

      let options = []

      numbers.forEach(n => {
        options.push({ value: n, name: n })
      })

      return options
    },
    optionProduct () {
      return this.$store.state.firstOptionProduct
    },
    productIsValid () {
      return this.selectedFrames.length === this.optionProduct.FramesRequired
    },
    primaryUiRowClasses () {
      return {
        'row': true,
        'row--mb-20': true,
        'row--pb-60': this.isTabletOrHigher
      }
    },
    content () {
      return this.$store.state.photoBookModuleContent
    },
    packageSubTotalFormatted () {
      const subTotal = this.selectedQuantity * this.offerPackage.EffectiveCost
      return currencyFormatter.format(subTotal, this.currentCultureNumberFormat, this.currency)
    },
    currentCultureNumberFormat () {
      return this.$store.state.catalogPageCommon.currentCultureNumberFormat
    },
    currency () {
      return this.$store.state.catalogPageCommon.currency
    },
    promoBanner () {
      return this.$store.state.catalogPageCommon.promoBanner
    },
    promoBannerInlineContext () {
      // this property determines the context passed to the PromoBanner component
      // the context determines whether it displays a border at the top of the component
      // if there's a quanity UI a border is needed. if there is no quantity UI then no border is needed

      if (this.offerPackage.CatalogPackage.MaxQtyAllowed > 1) { // quanity ui will show
        return 'inline'
      } else {
        return 'inline-no-border'
      }
    }
  },
  watch: {
    selectedQuantity (v, ov) {
      this.$store.commit('updatePackageQuantity', v)
    }
  },
  methods: {
    handleSelectedFramesUpdated (data) {
      this.selectedFrames = data.selectedFrames
    },
    handleAddToCartButtonClick () {
      this.showValidation = false

      if (this.productIsValid === false) {
        this.showValidation = true
        this.makeToast('error', this.contentfulText('photo-book-toast-error-title').Content, this.contentfulText('photo-book-toast-error-message').Content)
        return false
      } else {
        document.getElementById('add-to-cart-form').submit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-book {
  &__horizontal-rule {
    width: 100%;
    height: 1px;
    background-color: #000;
    margin-bottom: 20px;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__selection-group {
      padding: 0 20px;
    }
  }
}

.row {
  &--pb-60 {
    padding-bottom: 60px;
  }

  &--mb-40 {
    margin-bottom: 40px;
  }

  &--mb-20 {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-details/components/PhotoBook/PhotoBook.vue